// src/services/userService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getVolunteers = async () => {
  return await axios.get(`${API_URL}/volunteers/details`);
};

const getVolunteerById = async (id) => {
  return await axios.get(`${API_URL}/volunteers/${id}`);
};

const createVolunteer = async (data) => {
  return await axios.post(`${API_URL}/volunteers/`, data);
};

const updateVolunteer = async (id, data) => {
  return await axios.put(`${API_URL}/volunteers/${id}`, data);
};

const deleteVolunteer = async (id) => {
  return await axios.delete(`${API_URL}/volunteers/${id}`);
};

export default {
  getVolunteers,
  getVolunteerById,
  createVolunteer,
  updateVolunteer,
  deleteVolunteer,
};
